import { Col } from 'antd';
import React from 'react';

import * as style from './CardContainer.module.less';

const CardContainer = ({ children, ...rest }) => (
  <Col xs={12} lg={8} xl={6} className={style['card-container']} {...rest}>
    {children}
  </Col>
);

export default CardContainer;
